// eslint-disable-next-line import/no-extraneous-dependencies, import/default
import scheduler from "scheduler";
import { globalInputDelegate } from "./input";
scheduler.unstable_requestPaint = () => {
    globalInputDelegate.onReactCommit();
};
